import './utils/polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import {Router, useRouterHistory} from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import {createHashHistory} from 'history';
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import './css/main.css'
const store = configureStore()
window.store = store;

// Helpers for debugging
window.React = React;
window.Perf = require('react-addons-perf');

// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();


export default function init(Routes) {
  ReactDOM.render(
    <Provider store={store}>
      <Router
        history={useRouterHistory(createHashHistory)({queryKey: false})}
        onUpdate={() => window.scrollTo(0, 0)}>
        {Routes}
      </Router>
    </Provider>
  , document.getElementById('app'));
}





/** WEBPACK FOOTER **
 ** ./src/app/init.js
 **/